import type { ChatMode } from '../types';
import { formatWorkDuration } from './workDuration';

export const formatActivityDuration = formatWorkDuration;

export function getTypingIndicatorMessage(_mode: ChatMode, elapsedSeconds: number) {
  return `En proceso desde hace ${formatActivityDuration(elapsedSeconds * 1_000)}`;
}
